import { type QueryHookOptions, QueryResult } from "@apollo/client/react/types/types";
import { FIND_OWN_MEMBER_QUERY } from "../Queries";
import { useQuery } from "@apollo/client";
import { Member } from "../generated/graphql";
import { AuthContextProps } from "oidc-react";

export function useOwnMember(auth?: AuthContextProps, options?: QueryHookOptions): QueryResult<{ findOwnMember: Member | null }> {
    const user = auth?.userData;
    const signedIn = !!user;
    return useQuery(FIND_OWN_MEMBER_QUERY, {
        skip: !signedIn,
        ...options
    })
}